<template>
  <div class="singIn createAccount">
    <div class="logo">
      <div class="backIcon">
        <i
          class="el-icon-back cursor"
          @click="goBack"></i>
      </div>
      <div class="tvuLogo">
        <!-- <img src="./../assets/img/TVU networks Copy.png" alt=""> -->
      </div>
    </div>
    <div class="formBody">
      <div class="singInLabel">
        <p class="tvuSingIn">{{$t('lang.createAccount')}}</p>
        <p class="tvuDescribe">{{$t('lang.singInAccess')}} {{serviceName}}</p>
      </div>
      <div class="singInForm">
        <div class="name">
          <div class="exchange firstName">
            <div class="tip">{{$t('lang.firstName')}}</div>
            <el-input
              class="input focusFade"
              tabindex="1"
              v-model="firstName"
              :placeholder="$t('lang.firstName')"
              @keyup.enter.native="nextOpaertaion"
              @focus="focusInput"
              @blur="blurInput(1)"></el-input>
          </div>
          <div class="exchange lastName">
            <div class="tip">{{$t('lang.lastName')}}</div>
            <el-input
              class="input focusFade"
              tabindex='2'
              v-model="lastName"
              :placeholder="$t('lang.lastName')"
              @keyup.enter.native="nextOpaertaion"
              @focus="focusInput"
              @blur="blurInput(2)"></el-input>
          </div>
        </div>
        <div class="exchange emailArea ">
          <div class="tip">{{$t('lang.companyEmail')}}</div>
          <el-input
            class="input focusFade"
            tabindex='3'
            v-model="email"
            maxlength="50"
            :placeholder="$t('lang.companyEmail')"
            @keyup.enter.native="nextOpaertaion"
            @focus="focusInput"
            @blur="blurInput(3)"></el-input>
          <div class="warning">
            <i class="el-icon-warning-outline"></i>
            <span class="warningTip">{{emailErrorTip}}</span>
          </div>
        </div>
        <div class="exchange pswArea">
          <div class="tip">{{$t('lang.companyName')}}</div>
          <el-input
            class="input focusFade"
            tabindex='4'
            @focus="focusInput"
            @blur="blurInput(4)"
            @keyup.enter.native="nextOpaertaion"
            v-model="companyName"
            :placeholder="$t('lang.companyName')"></el-input>
          <div class="warning">
            <i class="el-icon-warning-outline"></i>
            <span class="warningTip">Enter email</span>
          </div>
        </div>
        <div class="exchange countryArea">
          <div class="tip">{{$t('lang.country')}}</div>
          <!-- <el-input class="input focusFade" tabindex='5'  @focus="focusInput" @blur="blurInput(5)" @keyup.enter.native="nextOpaertaion" v-model="country"  :placeholder="$t('lang.country')"></el-input>
					<div class="warning">
						<i class="el-icon-warning-outline"></i>
						<span class="warningTip">Select country</span>
					</div> -->
          <el-select
            popper-class="country-select"
            v-model="country"
            filterable
            @change="blurInput(5)"
            @visible-change="visibleChange"
            :placeholder="$t('lang.country')">
            <el-option
              v-for="item in countryArr"
              :key="item.val"
              :label="item.val"
              :value="item.val">
            </el-option>
          </el-select>
          <div class="warning">
            <i class="el-icon-warning-outline"></i>
            <span class="warningTip">Select country</span>
          </div>
        </div>
        <div class="exchange vertical">
          <el-input
            v-model="vcode"
            class="vcodeInput"
            maxlength="4"
            :placeholder="$t('lang.vcodePlaceholder')"
            @keyup.enter.native="nextOpaertaion"></el-input>
          <div class="vcode">
            <img
              :src="'data:image/jpeg;base64,'+imgUrl"
              alt=""
              @click='getVcode'>
          </div>
          <div class="warning">
            <i class="el-icon-warning-outline"></i>
            <span class="warningTip">{{$t('lang.vcodeEror')}}</span>
          </div>
        </div>
        <div class="confirmArea">
          <span
            class="cursor createAccount"
            @click="routerPush('/')">{{$t('lang.cancelLog')}}</span>
          <!-- :disabled='isDisabeBtn' -->
          <el-button
            :disabled='isDisabeBtn'
            class="confirmBtn cursor"
            v-repeat-click="{event:nextOpaertaion}">{{$t('lang.next')}}</el-button>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="divider"></div>
      <div class="policy">
        <el-checkbox v-model="checked"></el-checkbox>
        <span style='margin-left: 5px;'>{{$t('lang.operateInfo')}}</span>
        <span
          class="highLight cursor"
          @click="jumpToPolicy(2)">&nbsp;{{$t('lang.service')}}</span>
        <span>&nbsp;{{$t('lang.and')}}</span>
        <span
          class="highLight cursor"
          @click="jumpToPolicy(1)">&nbsp;{{$t('lang.policy')}}</span>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// imprort qs from  'qs';
import config from '@/assets/js/config.js'
import { getUrlParam } from '@/assets/js/utils'
import lodash from 'lodash'
export default {
  name: 'CreateAccount',
  data () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      companyName: '',
      vcode: '',
      isDisabeBtn: true,
      emailErrorTip: '',
      verifyCode: {},
      imgUrl: '',
      countryArr: config.country,
      country: '',
      countryPlac: this.$t('lang.country'),
      checked: false
    }
  },
  mounted () {
    // 中国区默认显示China
    if (location.host.includes('cn')) {
      this.country = 'China'
    }
    this.getVcode()
  },
  watch: {
    lastName: function () {
      if (!this.email || !this.companyName || !this.firstName || !this.lastName || !this.country || !this.vcode) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    },
    firstName: function () {
      if (!this.email || !this.companyName || !this.firstName || !this.lastName || !this.country || !this.vcode) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    },
    companyName: function () {
      if (!this.email || !this.companyName || !this.firstName || !this.lastName || !this.country || !this.vcode) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    },
    email: function () {
      if ($('.emailArea').hasClass('errorInput')) {
        $('.emailArea').removeClass('errorInput')
      }
      if (!this.email || !this.companyName || !this.firstName || !this.lastName || !this.country || !this.vcode) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    },
    country: function () {
      if ($('.countryArea').hasClass('errorInput')) {
        $('.countryArea').removeClass('errorInput')
      }
      if (!this.email || !this.companyName || !this.firstName || !this.lastName || !this.country || !this.vcode) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    },
    vcode: function () {
      if ($('.vertical').hasClass('errorInput')) {
        $('.vertical').removeClass('errorInput')
      }
      if (!this.email || !this.companyName || !this.firstName || !this.lastName || !this.country || !this.vcode) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    },
    key () {
      return this.$store.state.key
    },
    location () {
      return this.$store.state.location
    },
    serviceName () {
      if (this.$store.state.location && this.$store.state.location.split('&serviceName=')) {
        return this.$store.state.location.split('&serviceName=')[1]
      }
      return null
    }
  },
  methods: {
    jumpToPolicy (type) {
      ga('send', 'event', 'newUserService-createAccount-goToPolicy', 'click')
      if (type == 1) {
        window.open('https://www.tvunetworks.com/company-privacy-notice/', '_blank')
      } else {
        window.open('https://www.tvunetworks.com/company-terms-and-conditions/', '_blank')
      }
    },
    goBack () {
      ga('send', 'event', 'newUserService-createAccount-goBack', 'click')
      this.$router.go(-1)
    },
    // 路由跳转
    routerPush (path) {
      ga('send', 'event', 'newUserService-createAccount-leave', 'click')
      this.$router.push(path)
    },
    getVcode () {
      this.axios.get(
        '/userGroup/user-group/login/getVCode',
        {
          width: 80,
          height: 40
        }
      ).then((res) => {
        // if(res.data.errorCode == '0x0'){
        // 注册成功
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            this.imgUrl = res.data.result.vCode
            this.$store.state.key = res.data.result.key
          }
        } else {
          this.$message({
            message: this.$t('lang.error80943601'),
            type: 'error',
            duration: 3000
          })
        }
      }).catch(() => {
      })
    },
    // 防抖 防止多次点击，重复注册
    nextOpaertaion: lodash.debounce(function () {
      // 已创建，跳换至审核页
      // this.$router.push('/wait')
      // 未创建过，跳转至验证码
      ga('send', 'event', 'newUserService-createAccount-create', 'click')
      if (!this.email || !this.companyName || !this.firstName || !this.lastName || !this.vcode) {
        this.isDisabeBtn = true
        return
      }
      this.isDisabeBtn = false

      const reg = /^([\w+.-]*[+-]*\.*)+@(\w-?)+(\.\w{2,})+$/

      if (!reg.test(this.email)) {
        $('.emailArea').addClass('errorInput')
        this.emailErrorTip = 'Email format incorret'
        return
      }
      // 用户名长度不超过50个字符
      if (this.firstName.length + this.lastName.length > 50) {
        return this.$message.error(this.$t('lang.userNameLimit'))
      }
      // 验证勾选服务政策和隐私政策
      if (!this.checked) {
        return this.$message.warning(this.$t('lang.checkService'))
      }
      // if(!this.verifyCode.validate(this.vcode)){
      // 	$('.vertical').addClass('errorInput');
      // 	this.verifyCode.refresh();
      //     return;
      // }
      // 创建注册用户信息
      // this.$router.push('/verify');
      this.axios.post(
        '/userGroup/user-group/login/register',
        {
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName,
          company: this.companyName,
          country: this.country,
          imgCode: this.vcode,
          origin: getUrlParam('serviceName'),
          key: this.key,
          url: this.location
        }
        // {
        // 	headers: {
        // 		'Content-Type': 'application/x-www-form-urlencoded'
        // 	}
        // }
      ).then((res) => {
        // if(res.data.errorCode == '0x0'){
        // 跳转code页面
        if (res.data.errorCode == '80943101') {
          this.$store.state.userInfo = res.data.result
          localStorage.setItem('userInfo', JSON.stringify(res.data.result))
          sessionStorage.setItem('userInfo', JSON.stringify(this.$store.state.userInfo))
          this.$router.push({ path: '/verify', query: { verifyFlag: 1 } })
        } else if (res.data.errorCode == '80943103') { // 眺望密码页面
          this.$router.push('/register')
        } else if (res.data.errorCode == '80943701') { // 验证码过期
          this.getVcode()
        } else if (res.data.errorCode == '80943102') { // 验证码过期
          this.$message({
            message: this.$t('lang.error80943102'),
            type: 'error',
            duration: 3000
          })
        } else if (res.data.errorCode == '80943702') { // 验证码过期
          this.$message({
            message: this.$t('lang.error80943702'),
            type: 'error',
            duration: 3000
          })
        } else { // 用户已存在
          this.$message({
            message: res.data.errorInfo,
            type: 'error',
            duration: 3000
          })
        }
      }).catch(() => {
      })
    }, 500),
    visibleChange (flag) {
      flag ? this.focusInput('country') : this.blurInput(5)
    },
    focusInput (event) {
      if (event == 'country') {
        this.countryPlac = ''
        $('.createAccount .countryArea').find('.tip').css({
          display: 'inline-block',
          color: 'rgba(51,171,79,1)'
        })
      } else {
        $(event.target).parent().prev('.tip').css({
          display: 'inline-block',
          color: 'rgba(51,171,79,1)'
        })
      }
    },
    blurInput (num) {
      // num ,1代表email失去焦点，2代表companyName失去焦点'color':'rgba(153,153,153,1)'
      if (num != 5) {
        $(event.target).parent().prev('.tip').css('color', 'rgba(153,153,153,1)')
      } else {
        $('.createAccount .countryArea').find('.tip').css('color', 'rgba(153,153,153,1)')
      }
      if (num == 1) {
        this.firstName ? '' : $(event.target).parent().prev('.tip').css('display', 'none')
      } else if (num == 2) {
        this.lastName ? '' : $(event.target).parent().prev('.tip').css('display', 'none')
      } else if (num == 3) {
        this.email ? '' : $(event.target).parent().prev('.tip').css('display', 'none')
      } else if (num == 4) {
        this.companyName ? '' : $(event.target).parent().prev('.tip').css('display', 'none')
      } else if (num == 5) {
        if (!this.country) {
          this.countryPlac = this.$t('lang.country')
          $('.createAccount .countryArea').find('.tip').css('display', 'none')
        } else {
          $('.createAccount .countryArea').find('.tip').css('display', 'blcok')
        }
      }
    }
    /*  checkEmail () {
    const reg = /^([\w+.-]*[+-]*\.*)+@(\w-?)+(\.\w{2,})+$/
    if (!reg.test(email)) {

    }
  } */
  },
  filters: {
    getStrength (val) {
      switch (val) {
        case 2:
          return 'Low'
        case 4:
          return 'Middle'
        case 6:
          return 'High'
        default:
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.countryArea {
  .el-select {
    width: 100%;
  }
}
</style>
